<div [class]="'size-full shadow-xl  flex flex-col rounded-xl ' + cardClass">

  <!-- header -->
  <div
    [class]=" 'p-3 w-full flex items-center justify-start bg-primary h-[55px] rounded-t-xl shadow-xl ' + headerClass">
    <ng-content select="[header]"></ng-content>
  </div>

  <!-- content -->
  <div [class]="'size-full p-5  ' + contentClass">
    <ng-content select="[content]"></ng-content>
  </div>

</div>